<template>
	<div class="scrollTop" @click='scrollTop'>
		Top
	</div>
</template>

<script>
export default {
  methods: {
    scrollTop () {
      var dd = document.documentElement
      var db = document.body
      // var top = dd.scrollTop || db.scrollTop
      // var step = Math.floor(top / 20)
      let currtop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      var timmer = setInterval(() => {
        currtop -= 10
        db.scrollTop = currtop
        dd.scrollTop = currtop
        if (currtop <= 0) {
          clearInterval(timmer)
        }
      }, 1)
    }
  }
}
</script>

<style lang='scss' scoped>
	.scrollTop {
		display: inline-block;
		width: 40px;
		height: 40px;
		color: #f00;
		position: absolute;
		right: 0;
		bottom: 0;
		cursor: pointer;
		background: #e7eaf1;
	    border-radius: 4px;
	    line-height: 40px;
	}
</style>



// WEBPACK FOOTER //
// scolltotop.vue?1662b7f5